import { render, staticRenderFns } from "./ProjectStatusOverview.vue?vue&type=template&id=db5c656c"
import script from "./ProjectStatusOverview.vue?vue&type=script&lang=js"
export * from "./ProjectStatusOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports